import React from "react";

const WhyMarico = () => {
  return (
    <section>
      <div className="container">
        <div className="box">
          <h1 className="text-75 text-center -2xl:text-[60px] -xl:text-4xl -sm:text-3xl">Why Creators Love Marico</h1>
          <div className="flex justify-around mt-16 mb-162 items-end -xl:flex-wrap -xl:gap-4 -sm:mt-3 -sm:mb-6">
            <div className="left flex flex-col items-center -sm:text-center">
              <div className="flex items-center">
                <svg
                  width="37"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="18.4999" cy="18.5002" r="18.5" fill="#FFD93B" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.5029 30.3922C13.0954 30.3931 8.37628 26.7255 7.0419 21.4852C6.97 21.2174 7.0477 20.9315 7.2453 20.7369C7.4429 20.5424 7.72989 20.4691 7.99661 20.5452C8.26331 20.6211 8.46854 20.8347 8.5339 21.1042C9.69357 25.6626 13.7978 28.8534 18.5014 28.8534C23.205 28.8534 27.3092 25.6626 28.4689 21.1041C28.5791 20.6975 28.9953 20.4546 29.4036 20.5587C29.8119 20.6628 30.0609 21.0754 29.9629 21.4852C28.6295 26.7258 23.9104 30.3936 18.5029 30.3922Z"
                    fill="#3E4347"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36.9999 18.5033C36.9999 26.3439 32.0547 33.3343 24.6593 35.9456C17.2639 38.5568 9.02573 36.2211 4.10132 30.1169C11.4605 36.0486 22.1076 35.4788 28.7917 28.7954C35.4757 22.1122 36.0468 11.4651 30.1159 4.10522C34.4718 7.61511 37.0031 12.9093 36.9999 18.5033Z"
                    fill="#F4C534"
                  />
                  <ellipse
                    cx="12.5309"
                    cy="15.9252"
                    rx="2.835"
                    ry="3.369"
                    fill="#3E4347"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.8079 15.2001C13.5274 15.3618 13.1695 15.2767 12.9919 15.0061C12.8141 14.8754 12.7363 14.6478 12.7969 14.4357C12.8575 14.2235 13.0438 14.0714 13.2638 14.0543C13.4838 14.0372 13.6913 14.1588 13.7839 14.3591C14.0134 14.5889 14.0239 14.9576 13.8079 15.2001Z"
                    fill="#5A5F63"
                  />
                  <ellipse
                    cx="24.4809"
                    cy="15.9252"
                    rx="2.835"
                    ry="3.369"
                    fill="#3E4347"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.7559 15.2001C25.4754 15.3618 25.1175 15.2767 24.9399 15.0061C24.7621 14.8754 24.6843 14.6478 24.7449 14.4357C24.8055 14.2235 24.9918 14.0713 25.2118 14.0543C25.4318 14.0372 25.6393 14.1588 25.7319 14.3591C25.9614 14.5889 25.9719 14.9576 25.7559 15.2001Z"
                    fill="#5A5F63"
                  />
                </svg>
                <h2 className="ml-2 text-35 -2xl:text-3xl -sm:text-2xl">Reduced Anxiety</h2>
              </div>
              <p className="text-gray text-22 -2xl:text-lg">
                Never worry about losing your audience.
              </p>
            </div>
            <div className="center flex flex-col items-center -sm:text-center">
              <div className="flex items-center">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="16" cy="16.0002" r="16" fill="#FFD93B" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.793 20.9852C24.1411 24.9316 20.2812 27.5004 16.0029 27.5004C11.7247 27.5004 7.86481 24.9316 6.21295 20.9852C6.05701 20.6265 6.09875 20.2124 6.32324 19.8921C6.54767 19.5717 6.92255 19.3911 7.31293 19.4152C13.0971 19.7821 18.8987 19.7821 24.6829 19.4152C25.0734 19.392 25.4484 19.5721 25.6743 19.8916C25.9001 20.2111 25.9451 20.6246 25.793 20.9852Z"
                    fill="#3E4347"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.5729 16.0002C31.5761 22.6046 27.4122 28.4933 21.1838 30.692C14.9553 32.8907 8.0174 30.9211 3.87329 25.7777C10.0688 30.7758 19.0361 30.2974 24.6646 24.6686C30.2932 19.0398 30.7712 10.0725 25.7729 3.8772C29.4421 6.83154 31.5749 11.2894 31.5729 16.0002H31.5729Z"
                    fill="#F4C534"
                  />
                  <ellipse
                    cx="9.58005"
                    cy="11.7132"
                    rx="5.655"
                    ry="5.66"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.629 11.3541C13.6311 12.514 12.9336 13.561 11.8622 14.006C10.7908 14.4509 9.55688 14.2061 8.73657 13.3859C7.9162 12.5656 7.67126 11.3317 8.11609 10.2601C8.56091 9.18872 9.60779 8.49121 10.7679 8.49316C11.5271 8.49182 12.2556 8.79272 12.7925 9.32959C13.3293 9.86646 13.6303 10.595 13.629 11.3541Z"
                    fill="#3E4347"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.413 10.8103C12.218 11.0104 11.813 10.9174 11.508 10.6104C11.203 10.3033 11.108 9.91028 11.308 9.70532C11.508 9.50037 11.908 9.60535 12.213 9.90527C12.518 10.2053 12.617 10.6154 12.413 10.8103Z"
                    fill="white"
                  />
                  <ellipse
                    cx="22.42"
                    cy="11.7132"
                    rx="5.655"
                    ry="5.66"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.0911 11.3541C18.089 12.514 18.7864 13.561 19.8578 14.006C20.9292 14.4509 22.1631 14.2061 22.9835 13.3859C23.8038 12.5656 24.0488 11.3317 23.604 10.2601C23.1591 9.18872 22.1123 8.49121 20.9521 8.49316C20.193 8.49182 19.4645 8.79272 18.9276 9.32959C18.3907 9.86646 18.0897 10.595 18.0911 11.3541Z"
                    fill="#3E4347"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.3071 10.8103C19.5021 11.0104 19.907 10.9174 20.2121 10.6104C20.517 10.3033 20.6121 9.91028 20.412 9.70532C20.2121 9.50037 19.8121 9.60535 19.5071 9.90527C19.2021 10.2053 19.0991 10.6154 19.3071 10.8103Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.31305 19.4161C7.24603 19.4149 7.17914 19.42 7.11304 19.4312C8.92004 21.8782 12.2131 22.0132 15.996 22.0132C19.7791 22.0132 23.0721 21.8782 24.8791 19.4312C24.813 19.4203 24.746 19.4152 24.6791 19.4161C18.8961 19.7828 13.0958 19.7828 7.31287 19.4161H7.31305Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.998 27.5012C17.5624 27.5027 19.1077 27.1567 20.522 26.4883C20.4661 25.3923 20.0116 24.3545 19.2441 23.5703C18.6375 22.9619 17.7358 22.7555 16.925 23.0393C16.1608 23.3049 15.3572 23.4402 14.548 23.4392C13.0789 23.448 11.8216 24.4957 11.548 25.9392C11.5191 26.1243 11.5021 26.3109 11.4971 26.4982C12.9052 27.1598 14.4422 27.5023 15.998 27.5012Z"
                    fill="#E24B4B"
                  />
                </svg>

                <h2 className="ml-2 text-35 -2xl:text-3xl -sm:text-2xl">Lower Workload</h2>
              </div>
              <p className="text-gray text-22 -2xl:text-lg">
                Just share one link. We'll handle the rest.
              </p>
            </div>
            <div className="right flex flex-col items-center -sm:text-center">
              <div className="flex items-center">
                <svg
                  width="44"
                  height="43"
                  viewBox="0 0 44 43"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.5741 12.9863L21.0061 1.06628C21.1287 0.850342 21.3578 0.717041 21.6061 0.717041C21.8544 0.717041 22.0835 0.850342 22.2061 1.06628L29.6331 12.9863H13.5741Z"
                    fill="#955BA5"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.36096 2.16125C8.96326 2.16125 8.64099 1.83887 8.64099 1.44128V0.720215C8.64099 0.322632 8.96326 0.000244141 9.36096 0.000244141C9.75855 0.000244141 10.0809 0.322632 10.0809 0.720215V1.44019C10.0812 1.63135 10.0055 1.8147 9.87048 1.94995C9.73535 2.0852 9.55212 2.16125 9.36096 2.16125Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.36096 5.76111C8.96326 5.76111 8.64099 5.43872 8.64099 5.04114V4.32104C8.64099 3.92346 8.96326 3.60107 9.36096 3.60107C9.75855 3.60107 10.0809 3.92346 10.0809 4.32104V5.04114C10.0809 5.43872 9.75855 5.76111 9.36096 5.76111Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.92102 3.60107H7.20105C6.80347 3.60107 6.48108 3.27869 6.48108 2.8811C6.48108 2.4834 6.80347 2.16113 7.20105 2.16113H7.92102C8.31873 2.16113 8.64111 2.4834 8.64111 2.8811C8.64111 3.27869 8.31873 3.60107 7.92102 3.60107Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.522 3.60107H10.802C10.4043 3.60107 10.0819 3.27869 10.0819 2.8811C10.0819 2.4834 10.4043 2.16113 10.802 2.16113H11.522C11.9196 2.16113 12.2419 2.4834 12.2419 2.8811C12.2419 3.27869 11.9196 3.60107 11.522 3.60107Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.88 10.0812C2.4823 10.0812 2.15991 9.75879 2.15991 9.36121V8.64124C2.15991 8.24353 2.4823 7.92114 2.88 7.92114C3.27759 7.92114 3.59998 8.24353 3.59998 8.64124V9.36121C3.59998 9.75879 3.27759 10.0812 2.88 10.0812Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.88 13.6873C2.4823 13.6873 2.15991 13.365 2.15991 12.9673V12.2473C2.15991 11.8496 2.4823 11.5273 2.88 11.5273C3.27759 11.5273 3.59998 11.8496 3.59998 12.2473V12.9673C3.59998 13.365 3.27759 13.6873 2.88 13.6873Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.43994 11.5221H0.719971C0.322021 11.5221 -0.000488281 11.1995 -0.000488281 10.8015C-0.000488281 10.4037 0.322021 10.0811 0.719971 10.0811H1.43994C1.83789 10.0811 2.16052 10.4037 2.16052 10.8015C2.16052 11.1995 1.83789 11.5221 1.43994 11.5221Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.04102 11.5221H4.32104C3.9231 11.5221 3.60046 11.1995 3.60046 10.8015C3.60046 10.4037 3.9231 10.0811 4.32104 10.0811H5.04102C5.43896 10.0811 5.76147 10.4037 5.76147 10.8015C5.76147 11.1995 5.43896 11.5221 5.04102 11.5221Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M33.125 3.60144C32.7273 3.60144 32.405 3.27905 32.405 2.88135V2.16138C32.405 1.76379 32.7274 1.44141 33.125 1.44141C33.5227 1.44141 33.845 1.76379 33.845 2.16138V2.88135C33.8451 3.27905 33.5227 3.60144 33.125 3.60144Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M33.125 7.20129C32.7273 7.20129 32.405 6.87891 32.405 6.4812V5.76123C32.405 5.36365 32.7274 5.04126 33.125 5.04126C33.5227 5.04126 33.845 5.36365 33.845 5.76123V6.4812C33.8451 6.87891 33.5227 7.20129 33.125 7.20129Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.6849 5.04114H30.965C30.7075 5.0415 30.4695 4.9043 30.3406 4.6814C30.2117 4.4585 30.2118 4.18372 30.3406 3.96082C30.4695 3.73792 30.7075 3.60071 30.965 3.60107H31.6849C31.9424 3.60071 32.1804 3.73792 32.3093 3.96082C32.4381 4.18372 32.4381 4.4585 32.3093 4.6814C32.1804 4.9043 31.9424 5.0415 31.6848 5.04114H31.6849Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.286 5.04114H34.5659C34.3086 5.0415 34.0704 4.9043 33.9417 4.6814C33.8127 4.4585 33.8127 4.18372 33.9417 3.96082C34.0706 3.73792 34.3086 3.60071 34.566 3.60107H35.286C35.5435 3.60071 35.7815 3.73792 35.9104 3.96082C36.0392 4.18372 36.0392 4.4585 35.9103 4.6814C35.7815 4.9043 35.5435 5.0415 35.2859 5.04114H35.286Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M40.3259 10.8022C39.9283 10.8022 39.606 10.48 39.606 10.0823V9.3623C39.606 8.9646 39.9283 8.64233 40.3259 8.64233C40.7236 8.64233 41.046 8.9646 41.046 9.3623V10.0823C41.046 10.48 40.7236 10.8022 40.3259 10.8022Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M40.3259 14.4032C39.9283 14.4032 39.606 14.0808 39.606 13.6831V12.9631C39.606 12.5656 39.9283 12.2432 40.3259 12.2432C40.7236 12.2432 41.046 12.5656 41.046 12.9631V13.6831C41.046 14.0808 40.7236 14.4032 40.3259 14.4032Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M38.886 12.2422H38.166C37.7683 12.2422 37.446 11.9199 37.446 11.5222C37.446 11.1246 37.7683 10.8022 38.166 10.8022H38.886C39.2837 10.8022 39.606 11.1246 39.606 11.5222C39.606 11.9199 39.2837 12.2422 38.886 12.2422Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M42.4871 12.2422H41.767C41.3694 12.2422 41.047 11.9199 41.047 11.5222C41.047 11.1246 41.3694 10.8022 41.767 10.8022H42.4871C42.8846 10.8022 43.207 11.1246 43.207 11.5222C43.207 11.9199 42.8846 12.2422 42.4871 12.2422Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M37.446 26.6453C37.446 33.0532 33.5858 38.8302 27.6656 41.2823C21.7454 43.7345 14.9309 42.3789 10.3999 37.8475C5.8689 33.3163 4.51379 26.5018 6.96631 20.5817C9.41882 14.6616 15.196 10.8019 21.604 10.8022C25.8057 10.8022 29.8353 12.4714 32.8063 15.4426C35.7773 18.4138 37.4463 22.4435 37.446 26.6453Z"
                    fill="#F0C419"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.723 23.0443C18.5059 23.0446 18.3 22.9469 18.163 22.7783C17.6201 22.04 16.7584 21.6041 15.842 21.6041C14.9257 21.6041 14.0638 22.04 13.521 22.7783C13.2708 23.0874 12.8174 23.1353 12.5082 22.8851C12.199 22.635 12.151 22.1816 12.401 21.8723C13.2178 20.7959 14.4912 20.1636 15.8425 20.1636C17.1937 20.1636 18.4672 20.7959 19.2839 21.8723C19.4581 22.0883 19.4927 22.385 19.3729 22.6353C19.2532 22.8854 19.0004 23.0446 18.723 23.0443Z"
                    fill="#E57E25"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.9619 19.4432C12.7307 19.4431 12.5135 19.332 12.3783 19.1444C12.243 18.9569 12.2061 18.7157 12.2791 18.4962C12.9803 16.7767 14.7101 15.7053 16.562 15.8433C16.9596 15.8433 17.282 16.1656 17.282 16.5632C17.282 16.9609 16.9596 17.2832 16.562 17.2832C15.3326 17.1577 14.1597 17.8282 13.644 18.9513C13.546 19.2448 13.2714 19.4429 12.9619 19.4432Z"
                    fill="#2C2F38"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.245 23.0442C30.0266 23.0444 29.8198 22.9456 29.683 22.7753C29.14 22.0377 28.2788 21.6024 27.363 21.6024C26.4473 21.6024 25.5859 22.0377 25.043 22.7753C24.7927 23.0844 24.3394 23.1321 24.0302 22.882C23.7209 22.6318 23.673 22.1785 23.923 21.8693C24.7397 20.7927 26.0132 20.1604 27.3645 20.1604C28.7158 20.1604 29.9893 20.7927 30.806 21.8693C30.9801 22.0852 31.0148 22.3818 30.895 22.6321C30.7751 22.8823 30.5223 23.0415 30.245 23.0413V23.0442Z"
                    fill="#E57E25"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.244 19.4432C29.9363 19.4431 29.6626 19.2474 29.563 18.9563C29.0464 17.8331 27.8744 17.161 26.644 17.2822C26.2463 17.2822 25.924 16.96 25.924 16.5623C25.924 16.1647 26.2463 15.8423 26.644 15.8423C28.4958 15.7043 30.2256 16.7758 30.927 18.4952C30.9999 18.7147 30.9629 18.9558 30.8276 19.1434C30.6924 19.3311 30.4752 19.4421 30.2439 19.4423L30.244 19.4432Z"
                    fill="#2C2F38"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32.402 28.4592C32.402 28.9592 32.395 29.4463 32.3521 29.9423C32.316 30.5056 32.2439 31.0662 32.136 31.6202C32.1298 31.6758 32.1201 31.731 32.1069 31.7853C31.8351 33.1599 31.1898 34.4331 30.2419 35.4653C29.8616 35.9021 29.4343 36.2958 28.968 36.6393C28.2555 37.1831 27.4731 37.6288 26.642 37.9644C26.519 38.0143 26.39 38.0643 26.26 38.1083C25.921 38.2303 25.583 38.3313 25.2369 38.4253C24.2836 38.6758 23.3059 38.823 22.321 38.8643C22.0759 38.8783 21.838 38.8862 21.601 38.8862C21.364 38.8862 21.126 38.8793 20.881 38.8643C19.896 38.823 18.9185 38.6758 17.965 38.4253C17.62 38.3313 17.281 38.2313 16.942 38.1083C16.812 38.0643 16.683 38.0143 16.5599 37.9644C15.7288 37.6288 14.9465 37.1831 14.234 36.6393C13.7676 36.2958 13.3403 35.9021 12.96 35.4653C12.0122 34.4331 11.3669 33.1599 11.095 31.7853C11.0818 31.731 11.0721 31.6758 11.0659 31.6202C10.9581 31.0662 10.886 30.5056 10.85 29.9423C10.807 29.4423 10.7999 28.9553 10.7999 28.4592C10.807 28.2502 10.807 28.0413 10.822 27.8323C10.822 27.6882 10.829 27.5322 10.843 27.3933C10.8687 27.2651 10.8806 27.1348 10.8789 27.0042C10.8789 27.0043 11.131 27.1982 11.579 27.5043H11.5859C11.9459 27.7493 12.443 28.0582 13.0549 28.3972C13.455 28.6272 13.912 28.8652 14.402 29.0973C15.1173 29.4353 15.8519 29.7312 16.6019 29.9833C17.0559 30.1343 17.5239 30.2712 18.002 30.3833C18.9459 30.6166 19.9105 30.7566 20.882 30.8013C21.069 30.8082 21.256 30.8152 21.4509 30.8152H21.751C21.9449 30.8152 22.1329 30.8082 22.3199 30.8013C23.2913 30.7566 24.256 30.6166 25.2 30.3833C25.6819 30.2683 26.1499 30.1312 26.6 29.9833C27.35 29.7312 28.0846 29.4353 28.7999 29.0973C29.2899 28.8672 29.7429 28.6293 30.147 28.3972C30.7589 28.0582 31.2629 27.7422 31.6229 27.4973C32.0769 27.1973 32.323 26.9973 32.323 26.9973C32.3213 27.1278 32.3334 27.2582 32.3589 27.3862C32.3739 27.5303 32.3799 27.6863 32.3799 27.8252C32.3949 28.0343 32.3949 28.2433 32.402 28.4523V28.4592Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32.355 29.9423C32.319 30.5056 32.2468 31.0662 32.139 31.6202C31.5302 32.0421 30.8978 32.4291 30.245 32.7793C29.813 33.0173 29.3311 33.2543 28.8051 33.4923C28.1023 33.8136 27.3811 34.0924 26.645 34.3273C26.184 34.4783 25.702 34.6152 25.205 34.7273C24.259 34.9474 23.2952 35.0813 22.325 35.1272C22.1379 35.1272 21.951 35.1343 21.756 35.1343H21.4561C21.262 35.1343 21.074 35.1272 20.887 35.1272C19.9169 35.0813 18.9529 34.9474 18.0071 34.7273C17.507 34.6123 17.028 34.4752 16.567 34.3273C15.8309 34.0924 15.1096 33.8136 14.407 33.4923C13.881 33.2543 13.3989 33.0173 12.967 32.7793C12.3142 32.4291 11.6819 32.0421 11.073 31.6204C10.9651 31.0662 10.8929 30.5056 10.8569 29.9423C11.0436 29.9158 11.233 29.9651 11.3829 30.0792C11.8901 30.46 12.4191 30.8109 12.9669 31.1302C13.377 31.3752 13.86 31.6412 14.407 31.9082C15.1084 32.2531 15.8297 32.5559 16.567 32.8153C17.028 32.9742 17.51 33.1252 18.007 33.2473C18.9495 33.4917 19.9146 33.6389 20.887 33.6863C21.074 33.6932 21.261 33.7003 21.4561 33.7003H21.756C21.95 33.7003 22.1379 33.6934 22.325 33.6863C23.2975 33.6389 24.2626 33.4917 25.205 33.2473C25.705 33.1252 26.184 32.9733 26.645 32.8153C27.3823 32.5559 28.1035 32.2529 28.8051 31.9082C29.353 31.6412 29.835 31.3752 30.245 31.1302C30.793 30.8109 31.3218 30.46 31.829 30.0792C31.979 29.9651 32.1685 29.9158 32.355 29.9423Z"
                    fill="#E6E7E8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.323 30.8062V38.8643C22.078 38.8793 21.84 38.8862 21.603 38.8862C21.366 38.8862 21.1279 38.8793 20.8829 38.8643V30.8062C21.0699 30.8132 21.2579 30.8202 21.4519 30.8202H21.752C21.949 30.8213 22.136 30.8132 22.323 30.8062Z"
                    fill="#E6E7E8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.0029 30.3892V38.2241C18.0055 38.2927 17.9933 38.3608 17.967 38.4242C17.6219 38.3302 17.283 38.2302 16.944 38.1072C16.814 38.0642 16.6851 38.0132 16.562 37.9631V30.1932C16.563 30.1221 16.5752 30.0515 16.598 29.9841C17.052 30.1372 17.521 30.2742 18.0029 30.3892Z"
                    fill="#E6E7E8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4021 29.1003V36.1864C14.4045 36.3529 14.3453 36.5145 14.2361 36.6403C13.7697 36.2969 13.3424 35.9032 12.962 35.4664V28.7473C12.9596 28.6254 12.9922 28.5052 13.056 28.4014C13.4561 28.6313 13.9131 28.8693 14.4031 29.1013L14.4021 29.1003Z"
                    fill="#E6E7E8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.245 28.7472V35.4652C29.8646 35.902 29.4374 36.2957 28.9709 36.6392C28.8617 36.5134 28.8026 36.3518 28.8049 36.1853L28.8051 29.0992C29.295 28.8691 29.748 28.6312 30.152 28.3992C30.2158 28.5032 30.2485 28.6233 30.246 28.7452L30.245 28.7472Z"
                    fill="#E6E7E8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.641 30.1942V37.9642C26.5181 38.0142 26.389 38.0642 26.259 38.1082C25.92 38.2302 25.582 38.3312 25.2361 38.4252C25.2098 38.3618 25.1975 38.2937 25.2 38.2252V30.3901C25.682 30.2751 26.15 30.1382 26.6 29.9902C26.6228 30.0576 26.635 30.1282 26.636 30.1992L26.641 30.1942Z"
                    fill="#E6E7E8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.99805 29.2502C8.76099 29.2502 8.53931 29.1331 8.40601 28.937C8.27271 28.741 8.245 28.4917 8.33203 28.2712C8.42004 28.0553 9.30505 26.1343 13.2321 25.6663C13.627 25.6194 13.9851 25.9014 14.032 26.2963C14.079 26.6912 13.7969 27.0493 13.402 27.0963C10.3311 27.4633 9.66309 28.8153 9.65796 28.8282C9.53735 29.0841 9.28088 29.2482 8.99805 29.2504V29.2502Z"
                    fill="#E57E25"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M34.205 29.2653C33.9182 29.2656 33.6587 29.0959 33.5439 28.8333C33.517 28.7803 32.824 27.4652 29.799 27.1052C29.4041 27.0583 29.1221 26.7001 29.1689 26.3052C29.2159 25.9104 29.5741 25.6283 29.969 25.6753C33.8989 26.1443 34.7839 28.0632 34.869 28.2803C34.9587 28.5022 34.9324 28.7544 34.7983 28.9529C34.6644 29.1515 34.4404 29.2704 34.2009 29.2703L34.205 29.2653Z"
                    fill="#E57E25"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.96 7.09326C23.1129 6.2771 20.094 6.2771 17.2469 7.09326L21.006 1.06531C21.1285 0.849365 21.3577 0.716064 21.606 0.716064C21.8542 0.716064 22.0834 0.849365 22.2059 1.06531L25.96 7.09326Z"
                    fill="#B49ACA"
                  />
                </svg>

                <h2 className="ml-2 text-35 -2xl:text-3xl -sm:text-2xl">More Time</h2>
              </div>
              <p className="text-gray text-22 -2xl:text-lg">
                Spend less time on marketing tools
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyMarico;
